<script>
    import Loader from '../../atoms/Loader.svelte'
    export let loginFailed;
    
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") {
            loginFailed = false;
        }else {
            // If the splash screen is visible for more than 10 seconds, show reload option
            setTimeout(() => {
                loginFailed = true;
            },10000)
        }
    })

</script>

<style lang="scss" src="./Splash.scss"></style>

<div class="splash">
    <img src="./assets/svg/logo_yellow.svg" width="81" alt="Originea logo" class="splash__graphic">
    <Loader />
    {#if loginFailed }
        <button class="btn btn--tertiary is-outline btn--reload" on:click={() => window.location.reload()}>Stuck? Try again</button>
    {/if}
</div>